import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import { reloadForStaleBuild } from './app/chunk-load'
import './styles.css'

// Vite reports a dependency of a lazy screen it could not preload, which after a
// deploy means this tab holds an old build. One reload fetches the new one;
// if that has already been tried the import fails on and the error boundary
// around the routes says so (D1-05).
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForStaleBuild()) event.preventDefault()
})

const root = document.getElementById('root')
if (!root) throw new Error('no #root in the page')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
